import NewProductTHead from '../../../common/theads/NewProductTHead';
import { useDispatch, useSelector } from 'react-redux';
import { Product } from '../../../../types/product';
import { selectClientSpecialPackageItems, setAddItemToSpecialPackage } from '../../../../features/client/clientSlice';
import { selectedSizeInterface } from '../../../modals/Admin/SpecialPackageModal';
import { SizeData } from '../../../../features/setup/setupResponse';

interface ClientSpecialProductProps {
    getSizes: SizeData[]
    selectedSize: selectedSizeInterface | null
    setSelectedSize: (value: selectedSizeInterface | null) => void;
    filteredProducts: Product[] | undefined
}

export default function ClientSpecialProduct({ getSizes, setSelectedSize, selectedSize, filteredProducts }: ClientSpecialProductProps) {

    const dispatch = useDispatch()
    const specialPackageItems = useSelector(selectClientSpecialPackageItems)

    return (
        <>
            <div className="grid grid-cols-1 gap-2">
                <div className='grid grid-cols-4 gap-1.5 p-1'>
                    {getSizes.map((size: SizeData) => {
                        return (
                            <div 
                                key={size.sizeId}
                                onClick={() => setSelectedSize({sizeId: size.sizeId, size: size.size})}
                                className={`cursor-pointer bg-gray-200 border ${size.sizeId === selectedSize?.sizeId ? 'border-cbColor' : ''}  rounded flex items-center justify-center`}
                            >
                                <div className='flex justify-center p-1 text-sm items-center text-center text-cbColorDark'>
                                    {size.size}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
            
            <NewProductTHead isShowPrice={false}/>
            <div className="flex-1 overflow-hidden h-full rounded">
                <div className='h-full rounded overflow-y-auto'>
                    <div>
                        <div className='flex-1 overflow-hidden h-full rounded'>
                            <div className="p-2 h-full rounded overflow-y-auto">
                                <div className="grid grid-cols-1 gap-2">
                                    {filteredProducts?.map((product) => {
                                        const isInPackage = specialPackageItems?.some((item) => item.id === product.productID && item.name === product.productName);
                                        const firstWord = product.categoryInfo?.categoryName?.split(" ")[0] || "";
                                        return (
                                            <div key={product.productID} 
                                                className={`cursor-pointer transition-colors ${
                                                    isInPackage
                                                    ? "border-[1px] border-cbColor bg-blue-50 hover:bg-blue-100"
                                                    : "border"
                                                } rounded`}
                                            >
                                                <div className="border border-gray-200 flex flex-col p-2.5 space-y-1 rounded bg-gray-100 transition-colors">
                                                    <div className="grid [grid-template-columns:2fr_1fr_0.5fr_0.5fr_auto] gap-2 w-full text-[12px] items-center">
                                                        <div className="font-medium truncate">{`${firstWord} | ${product.productName}`}</div>
                                                        <div className="truncate">{product.sizeInfo.size === 'None' ? '' : product.sizeInfo.size}</div>
                                                        <div className="flex justify-center" >
                                                            <input
                                                                type="checkbox"
                                                                checked={isInPackage}
                                                                onChange={() => dispatch(setAddItemToSpecialPackage({
                                                                    id: product.productID, 
                                                                    name: product.productName,
                                                                    categoryInfo: product.categoryInfo,
                                                                    sizeInfo: product.sizeInfo,
                                                                    depositAmount: 0,
                                                                    depositDate: '',
                                                                    receiptNumber: '',
                                                                }))}
                                                                className="cursor-pointer accent-cbColor"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
